import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

const GetSelfCheckoutDashboard = ({ from, to, granularity, autocartPage = 1, autocartPageSize = 20 }) => {
    return useQuery(
        ["get-self-checkout-dashboard", from, to, granularity, autocartPage, autocartPageSize],
        () =>
            request({
                url: `journeyEvent/admin/dashboard?from=${from}&to=${to}&granularity=${granularity}&autocartPage=${autocartPage}&autocartPageSize=${autocartPageSize}`,
                method: "GET",
            }),
        {
            enabled: !!from && !!to,
            keepPreviousData: true,
        }
    );
};

export default GetSelfCheckoutDashboard;
